import {Button, ButtonProps, Menu} from "@mui/material";
import React, {ReactNode} from "react";

interface DropdownMenuProps extends ButtonProps
{
	children: ReactNode;
	label: ReactNode;
}

export function DropdownMenu(props: DropdownMenuProps) {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	
	return <div>
		<Button
			{...props}
			id="basic-button"
			aria-controls={open ? "basic-menu" : undefined}
			aria-haspopup="true"
			aria-expanded={open ? "true" : undefined}
			onClick={handleClick}
		>
			{props.label}
		</Button>
		<Menu
			anchorEl={anchorEl}
			open={open}
			onClose={handleClose}
			MenuListProps={{
				"aria-labelledby": "basic-button",
			}}
		>
			{props.children}
		</Menu>
	</div>;
}
